import React from 'react'
import Checkbox from 'components/checkbox'
import InfoHint from 'components/info-hint'
import SelectSourceFields, {
  LIVE_VALUES_HELP,
  AUTOPOPULATE_HELP
} from 'components/spreadsheet/components/column/select-source-fields'
import { usePicker } from './context'

// "From a table" mode of a select column's options: the shared source table→view→column dropdowns plus
// the add-flow's live-values / auto-populate toggles. The selection is held on the picker's draft and
// written to kindOptions when the column is created. The two explanations are the same ones Edit Column
// shows, surfaced here on hover of an info icon to keep the compact add-column menu uncluttered.
const SelectSource: React.FC = () => {
  const { selectSource, updateSelectSource } = usePicker()

  return (
    <div className="pt-4">
      <SelectSourceFields
        tableId={selectSource.tableId}
        viewId={selectSource.viewId}
        columnId={selectSource.columnId}
        onTableChange={(tableId) => updateSelectSource({ tableId, viewId: '', columnId: '' })}
        onViewChange={(viewId) => updateSelectSource({ viewId, columnId: '' })}
        onColumnChange={(columnId) => updateSelectSource({ columnId })}
      />

      <div className="mt-4 px-2.5">
        <div className="flex items-center gap-1">
          <Checkbox
            checked={selectSource.liveValues}
            onChange={(event) => updateSelectSource({ liveValues: event.target.checked })}
          >
            Keep Values Up To Date
          </Checkbox>
          <InfoHint content={LIVE_VALUES_HELP} />
        </div>
        <div className="flex items-center gap-1">
          <Checkbox
            checked={selectSource.autopopulate}
            onChange={(event) => updateSelectSource({ autopopulate: event.target.checked })}
          >
            Auto-Populate New Row Values
          </Checkbox>
          <InfoHint content={AUTOPOPULATE_HELP} />
        </div>
      </div>
    </div>
  )
}

export default SelectSource
